
import { Options, Vue } from "vue-class-component";
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import TheBackdrop from "@/components/TheBackdrop.vue";
import AboutMe from "@/components/AboutMe.vue";
import Career from "@/components/Career.vue";
import Projects from "@/components/Projects.vue";
import Contacts from "@/components/Contacts.vue";
@Options({
  components: {
    TheHeader,
    TheFooter,
    TheBackdrop,
    AboutMe,
    Career,
    Projects,
    Contacts,
  },
})
export default class App extends Vue {}
